import { cn } from '@/core/lib/utils/cn'
import { RemoteImage } from '@/core/ui/atoms/remote-image'
import { Check } from 'lucide-react'

export const CountryOption: React.FC<{
  selected: boolean
  name: string
  flag: string
}> = ({ name, flag, selected }) => {
  return (
    <div
      className={cn(
        'flex w-full items-center justify-between gap-2 text-base font-medium hover:bg-gray-100',
        selected ? 'text-navy' : 'text-grey-50',
      )}
    >
      <span className='flex flex-shrink-0 items-center gap-2'>
        <RemoteImage src={flag} alt={name} width={20} height={20} />
        {name}
      </span>

      {selected ? (
        <span>
          <Check className='font-light' />
        </span>
      ) : null}
    </div>
  )
}
